// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3m4AG","header":"PatientBlock_header__3mUoV","label":"PatientBlock_label__1ZxTj","option":"PatientBlock_option__1eX9c"};